<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'App',
    data(){
      return{
      }
    },
    computed: {
    },
    mounted(){

    },
    methods:{
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue